"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaAnswerTrailListLink = void 0;
var _CLink = _interopRequireDefault(require("01_core/components/materials/CLink"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _kansaAnswerActions = require("./kansaAnswerActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 監査証跡一覧画面（参照）
 */
const StyledContainer = (0, _styles.styled)('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  height: '100%'
});
const StyledLabel = (0, _styles.styled)(_material.Typography)(_ref => {
  let {
    theme
  } = _ref;
  return {
    background: theme.palette.table.header.primary.main,
    color: theme.palette.table.header.primary.contrastText,
    display: 'flex',
    padding: theme.spacing(1),
    border: 'solid 1px ' + theme.palette.border.gray,
    alignItems: 'center',
    fontSize: theme.typography.body2.fontSize
  };
});
const StyledValue = (0, _styles.styled)(_material.Typography)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(1),
    border: 'solid 1px ' + theme.palette.border.gray,
    color: theme.palette.accent.main,
    fontSize: theme.typography.body2.fontSize,
    gap: theme.spacing(0.5),
    '& a': {
      textDecoration: 'underline'
    }
  };
});
class KansaAnswerTrailListLink extends _react.default.Component {
  constructor(props) {
    super(props);
    /**
     * 監査証跡情報検索処理
     */
    _defineProperty(this, "searchTrailData", () => {
      const {
        callAPI,
        kansaInfo,
        openInfoBar,
        setSearchTrailResult
      } = this.props;
      callAPI(_APIs.KANSA_ANSWER_TRAIL_SEARCH, {
        kansaTgtNendo: kansaInfo.kansaTgtNendo,
        kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId
      }).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setSearchTrailResult(response.data);
        } else {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
        }
      });
    });
    if (this.props.searchTrailResult.length === 0) {
      // 監査証跡情報
      this.searchTrailData();
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      openInfoBar,
      intl,
      kansaInfo
    } = this.props;

    // 証跡ファイルリンク押下ダウンロードハンドラ
    const fileDownload = (eviNo, fileNm) => {
      // 監査証跡情報
      const sendData = {
        kansaTgtNendo: kansaInfo.kansaTgtNendo,
        kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId,
        eviNo: eviNo,
        fileNm: fileNm
      };
      this.props.callAPIRawResponse(_APIs.KANSA_ANSWER_TRAIL_FILE_DOWNLOAD, sendData).then(response => response.blob()).then(blob => {
        if (blob.size > 0) {
          let anchor = document.createElement('a');
          anchor.download = fileNm;
          anchor.href = window.URL.createObjectURL(blob);
          anchor.click();
        } else {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
            id: _labelConsts.LABEL.CORE_FILE_NOT_FOUND_MESSAGE
          }));
        }
      });
    };
    const createData = () => {
      return this.props.searchTrailResult.map(item => /*#__PURE__*/_react.default.createElement("div", {
        key: item.eviNo
      }, /*#__PURE__*/_react.default.createElement(_CLink.default, {
        onClick: () => {
          fileDownload(item.eviNo, item.fileNm);
        }
      }, item.eviDocNm)));
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(StyledContainer, null, /*#__PURE__*/_react.default.createElement(StyledLabel, {
      style: {
        width: 150
      }
    }, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_TRAIL
    })), /*#__PURE__*/_react.default.createElement(StyledValue, {
      component: "div",
      style: {
        width: "calc(100% - ".concat(150, "px)")
      }
    }, createData())))));
  }
}
exports.KansaAnswerTrailListLink = KansaAnswerTrailListLink;
const mapStateToProps = state => {
  return {
    kansaInfo: state.kansaAnswer.kansaInfo,
    searchTrailResult: state.kansaAnswer.searchTrailResult
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setSearchTrailResult: resultList => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_SEARCH_TRAIL_RESULT](resultList)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)((0, _CodeUtil.withCodeUtil)(KansaAnswerTrailListLink))));